module.exports = __webpack_public_path__ + "static/img/icon-success.3f3ba949.png";